import { notifyError, notifySuccess } from "@lib/helper"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import { ProjectMasterDetailModel } from "@models/project/projectModel"
import { downloadFile } from "@lib/helperFile"
import dayjs from "dayjs"

class ProjectMasterService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Project/GetAll", {
      params,
    })
    return res.data.result
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/Project/Get", {
      params: { id },
    })
    const { result } = res.data

    return ProjectMasterDetailModel.assign(result)
  }
  public async createOrUpdate(body: any) {
    const res = await http.post("api/services/app/Project/CreateOrUpdate", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async active(id: number, isActive) {
    const res = await http.post(
      "api/services/app/Project/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async GetListTownshipForAdmin(params?: any): Promise<any> {
    const res = await http.get("/api/services/app/Township/GetListForAdmin", {
      params,
    })
    const { result } = res.data

    return result
  }

  // ProjectConfig
  public async getProjectSetting(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/Project/GetProjectSetting", {
      params: { projectId: id },
    })
    const { result } = res.data

    return result
  }

  public async createOrUpdateSettings(body: any): Promise<any> {
    const res = await http.post(
      "api/services/app/Project/CreateOrUpdateSettings",
      body
    )
    const { result } = res.data
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return result
  }

  // Project account
  public async getAllProjectAccount(params: any): Promise<any> {
    const res = await http.get("api/services/app/ProjectAccount/GetAll", {
      params,
    })
    return res.data.result
  }

  public async getProjectAccount(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/ProjectAccount/Get", {
      params: { id },
    })
    const { result } = res.data

    return result
  }
  public async createOrUpdateProjectAccount(body: any) {
    const res = await http.post(
      "api/services/app/ProjectAccount/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async activeProjectAccount(id: number, isActive) {
    const res = await http.post(
      "api/services/app/ProjectAccount/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async exportExcel(params: any, name?: string): Promise<any> {
    const res = await http.get("api/Export/ExportProject", {
      params,
      responseType: "blob",
    })
    downloadFile(
      res.data,
      `${name || "EXPORT-PROJECT"}-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`
    )
  }
  public async importProject(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)

    const result = await http.post("api/Imports/ImportProject", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })

    return result.data.result
  }
}

export default new ProjectMasterService()
